import { Drawer, List, Skeleton, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import useGetScheduledSessions from '../hooks/useGetScheduledSessions';

interface ScheduledSessionsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export interface ScheduleRunItem {
  shared_session_id: string;
  display_name: string;
  timestamp: string;
}

const { baseUrl } = window.conviva;

const ScheduledSessions = ({ open, setOpen }: ScheduledSessionsProps) => {
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
  };

  const { data = [], isFetching } = useGetScheduledSessions({ open });
  const runs = data as ScheduleRunItem[];

  const handleItemClick = (item: ScheduleRunItem) => {
    navigate(`${baseUrl}/nx/share/${item.shared_session_id}`);
    handleClose();
  };

  return (
    <Drawer
      title="Scheduled Analysis Runs"
      placement="left"
      closable={true}
      onClose={handleClose}
      open={open}
      width={450}
    >
      {isFetching ? (
        <Skeleton active />
      ) : runs.length === 0 ? (
        <Typography.Text type="secondary">No scheduled sessions found</Typography.Text>
      ) : (
        <List
          size="small"
          dataSource={runs}
          renderItem={(item: ScheduleRunItem) => (
            <List.Item
              style={{ cursor: 'pointer', padding: '12px 0' }}
              onClick={() => handleItemClick(item)}
            >
              <List.Item.Meta
                title={item.display_name}
                description={
                  item.timestamp ? moment(item.timestamp).format('MMM D, YYYY h:mm A') : null
                }
              />
            </List.Item>
          )}
        />
      )}
    </Drawer>
  );
};

export default ScheduledSessions;
